module.exports = __webpack_public_path__ + "img/CapVentas.6f4a772a.png";